<template>
  <div id="home-info" class="m-grid__item m-grid__item--fluid m-grid m-grid--center m-grid--hor m-grid__item--order-tablet-and-mobile-1  m-login__content">
    <div class="m-grid__item m-grid__item--middle">
      <h3 class="m-login__welcome">
        Simple & Convenient
      </h3>
      <p class="m-login__msg">
        The ideal and secure way to pay for your county services online.
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Welcome'
}
</script>
<style type="text/css">
#home-info {
  background-image: url(../../../static/img/Group.png);
}
</style>



// WEBPACK FOOTER //
// src/components/partials/Welcome.vue